import React, { Component } from 'react'

import { get } from '../../api'
import { formatDateSince } from '../../format-date'

import './Home.css'

const formatNumber = (num) => {
  const a = num.toString()
  return a.toString().replace(new RegExp("^(\\d{" + (a.length%3?a.length%3:0) + "})(\\d{3})", "g"), "$1 $2").replace(/(\d{3})+?/gi, "$1 ").trim()
}

class Home extends Component {

    state = {}

    componentDidMount() {
        this.fetchStatus()
        this.fetchLogs()
        this.interval = setInterval(this.fetchLogs, 5000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    fetchStatus = async () => {
        try {
            const status = await get('/')
            this.setState({ status })
        } catch (err) {
            alert(err.message)
        }
    }

    fetchLogs = async () => {
        try {
            const logs = await get('/logs')
            this.setState({ logs })
        } catch (err) {
            alert(err.message)
        }
    }

    render() {

        const { status, logs = [] } = this.state

        return (
            <div className="Home">
                { status && (
                    <div>
                        <h2>Stats</h2>
                        <ul className="stats">
                            <li>
                                <span>{formatNumber(status.lbus)}</span>
                                <span>LBUs</span>
                            </li>
                            <li>
                              <span>{formatNumber(status.categories)}</span>
                              <span>Categories</span>
                            </li>
                            <li>
                              <span>{formatNumber(status.crawled.brands)}</span>
                              <span>Brand Pages</span>
                            </li>
                            <li>
                              <span>{formatNumber(status.crawled.categories)}</span>
                              <span>Category Pages</span>
                            </li>
                            <li>
                              <span>{formatNumber(status.crawled.products)}</span>
                              <span>Product Pages</span>
                            </li>
                        </ul>
                    </div>
                )}
                <h2>Activity</h2>
                <ul className="logs">
                    {logs.map((log, index) => {
                        return (
                            <li key={index}>
                                <span>{formatDateSince(new Date(log.time))}</span>
                                <p>{log.message}</p>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }
}

export default Home



// WEBPACK FOOTER //
// ./src/components/Home/Home.js